import {userService} from 'src/modules/user/UserService';
import {BackEndService} from 'src/utils/BackEndService';

function shouldFilterSongs() {
  return process.env.FREE_SONG_FILTER && !userService.user.hasAccessHiddenCatalog;
}

export function loadCatalogOptions({commit}) {
  return BackEndService.sendGetRequest('catalog-options').then((response) => {
    commit('SET_CATALOG_OPTIONS', response.content);
    return response.content;
  });
}

export function loadRecommendedSongs({dispatch, commit}) {
  dispatch('getFilteredSongList', {perPage: 10, sort: 'recommended'}).then(function (content) {
    commit('SET_RECOMMENDED_SONGS', content.data);
  });
}
export function loadNewSongs({dispatch, commit}) {
  dispatch('getFilteredSongList', {perPage: 10, sort: 'recent', withoutMyPieces: true}).then(function (content) {
    commit('SET_NEW_SONGS', content.data);
  });
}
export function loadUserVersions({commit}) {
  BackEndService.sendGetRequest('catalog-home').then((response) => {
    commit('SET_USER_PIECES', response.content);
  });
}

export function loadFilteredSongs({dispatch, commit, getters, state}) {
  const filteringParameters = getters.getCurrentFilteringParameters;
  if (shouldFilterSongs()) {
    if (!filteringParameters.catalog_type) {
      filteringParameters.catalog_type = 'FREE|PREMIUM';
    }
  }
  const currentSearchPromiseKey = Math.random();

  if (JSON.stringify(state.lastFilteredSongsParameters) !== JSON.stringify(filteringParameters)) {
    commit('CLEAR_FILTERED_SONGS');
    commit('SET_CURRENT_SEARCH_PROMISE_KEY', currentSearchPromiseKey);
    dispatch('getFilteredSongList', filteringParameters).then(function (content) {
      if (currentSearchPromiseKey === state.currentSearchPromiseKey) {
        commit('SET_FILTERED_SONGS_PARAMETERS', filteringParameters);
        commit('SET_FILTERED_SONGS', content);
      }
    });
  }
}

export function resetAllSearchOptions({commit}) {
  commit('SET_SEARCH_VALUE', '');
  commit('SET_SELECTED_SORT', {option: 'master', french: 'Maîtrise'});
  commit('SET_CURRENT_PAGE', 1);
  commit('RESET_SELECTED_FILTERS');
}

export function getFilteredSongList(_, parameters) {
  if (parameters.draftCatalog === undefined) {
    parameters.draftCatalog = userService.user.configurations.catalogType === 'draft';
  }
  if (parameters.perPage === undefined) {
    parameters.perPage = 15;
  }

  return BackEndService.sendGetRequest('catalog', parameters).then(function (response) {
    return response.content;
  });
}

export function updateRouteParams({getters}) {
  const params = getters.getCurrentFilteringParameters;
  this.$router.push({query: JSON.parse(JSON.stringify(params)), params: {savePosition: true}}, () => {});
}

export async function getChallengesDifficultyData({commit}, {difficulty, page, search}) {
  BackEndService.sendGetRequest(`challenge/catalog?difficulty=${difficulty}&page=${page || 1}&search=${search}`).then((result) => {
    commit('SET_CHALLENGES_DIFFICULTY_DATA', {difficulty, challenges: result.content});
  });
}
